import { useTranslation } from 'react-i18next';
import './knowledgeModal.css';

// Shared by knowledgeModal.js / knowledgeDocumentModal.js: a knowledge item's
// text can be multi-MB (a 4.7k-row spreadsheet, a huge scraped page). Rendering
// that in one <pre> froze the portal, so the preview asks the API for the first
// PREVIEW_MAX_CHARS only (GET /api/knowledge/:id?max_chars=N returns
// relevant_data cut to N plus total_chars / truncated) and offers "Load full
// text" for the rare case someone really wants all of it.
export const PREVIEW_MAX_CHARS = 300000;

export async function fetchKnowledgePreview(knowledgeId, { full = false } = {}) {
  const qs = full ? '' : `?max_chars=${PREVIEW_MAX_CHARS}`;
  const response = await fetch(`${process.env.REACT_APP_API_BASE_URL}knowledge/${knowledgeId}${qs}`);
  if (!response.ok) {
    throw new Error(`Failed to fetch knowledge data. Status: ${response.status}`);
  }
  return response.json();
}

function fmtSize(chars) {
  if (!chars && chars !== 0) return '';
  if (chars >= 1000000) return `${(chars / 1000000).toFixed(1)} MB`;
  if (chars >= 1000) return `${Math.round(chars / 1000)} KB`;
  return `${chars} B`;
}

// Banner shown above a truncated preview. `onLoadFull` re-fetches without the
// cap; `loadingFull` swaps the button for a hint while that runs.
export function KnowledgePreviewNotice({ shownChars, totalChars, onLoadFull, loadingFull }) {
  const { t } = useTranslation();
  return (
    <div className="knowledge-preview-notice" role="status">
      <span>
        {t('knowledge_preview_truncated', 'Showing the first {{shown}} of {{total}}.', {
          shown: fmtSize(shownChars),
          total: fmtSize(totalChars),
        })}
      </span>
      {loadingFull ? (
        <span className="knowledge-preview-notice-hint">{t('knowledge_preview_loading_full', 'Loading full text…')}</span>
      ) : (
        <button type="button" className="knowledge-preview-notice-btn" onClick={onLoadFull}>
          {t('knowledge_preview_load_full', 'Load full text')}
        </button>
      )}
    </div>
  );
}
